import { render, staticRenderFns } from "./Apps.vue?vue&type=template&id=522def98&scoped=true"
import script from "./Apps.vue?vue&type=script&setup=true&lang=js"
export * from "./Apps.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Apps.vue?vue&type=style&index=0&id=522def98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522def98",
  null
  
)

export default component.exports